import { toast } from "sonner";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function MoveRequestToRoute(
  routes: RouteModel[],
  dropResult: DropResult,
): RouteModel[] {
  if (!dropResult.destination) {
    return routes;
  }

  // Get the draggable element.
  const draggable = dropResult.draggableId;
  const requestId = draggable.replace("request:", "");

  const request = routes
    .flatMap((r) => r.packingSlips)
    .flatMap((p) => p.requests)
    .find((request) => request.id === requestId);

  if (!request) {
    toast.error("Could not find request:" + requestId + " to move");
    return routes;
  }

  // Get the destination element and move the draggable from old to new place.
  const destination = dropResult.destination.droppableId;
  const routeId = destination.replace("route:", "");

  return routes.map((route) => {
    //Remove request from old packing slip.
    route.packingSlips = route.packingSlips
      .map((slip) => {
        slip.requests = slip.requests.filter((req) => req.id !== request.id);
        return slip;
      })
      .filter((slip) => slip.requests.length > 0);

    //Add slip to new route.
    if (route.id === routeId) {
      const existingSlip = route.packingSlips.find(
        (slip) => slip.relation.id === request.relation.id,
      );
      if (existingSlip) {
        existingSlip.requests.push(request);
      } else {
        route.packingSlips.push({
          id: "state:" + route.truck?.id + "-" + request.relation.id,
          requests: [request],
          relation: request.relation,
          status: "draft",
          date: route.date,
        });
      }
    }

    return route;
  });

  return routes;
}
